import React, {useState, useEffect} from 'react';
import ReactSelect from '../../Shared/ReactSelect/ReactSelect';
import {connect} from 'react-redux';

const SubscriberSection = ({allSubscribers, currentSubscriber, setSubscriber}) => {
  const filteredSubscribers = allSubscribers.filter((subscriber) => subscriber !== "0000000000");
  return (
    <div className='subscriber-Section'>
      <label className='subscriber-Section__topic'>בחר מנוי לצפיה במידע על התוכנית</label>
      <ReactSelect
        placeholderColor='#4a4a4a'
        options={filteredSubscribers}
        blurInputOnSelect={true}
        getOptionLabel={(option) => option}
        getOptionValue={(option) => option}
        onChange={(e) => setSubscriber(e)}
        value={allSubscribers.filter((option) => option === currentSubscriber)}
        name='subscriber'
        placeholder={currentSubscriber}
        isDisable={allSubscribers.length <= 1}
      />
    </div>
  );
};

export default SubscriberSection;
